import * as Sentry from "@sentry/react";
import { RewriteFrames } from "@sentry/integrations";
import { uuid4 } from "@sentry/utils";

let candyHub = new Sentry.Hub();

export function getCandyHub(): Sentry.Hub {
    return candyHub;
}

function isCandySentryEvent(event: Sentry.Event): boolean {
    if (event.exception == undefined) {
        return true;
    }
    if (event.exception.values?.[0]?.stacktrace?.frames?.length === 1) {
        return true;
    }
    return event.exception.values?.[0]?.stacktrace?.frames?.slice(1).some(x => x.filename?.includes("candy")) ?? false;
}

export function initializeSentry(): void {
    function getSentryEnvironment(): string {
        if (process.env.ENGINE_NAME !== "local") {
            if (window.location.hostname.includes("localhost") || window.location.hostname.startsWith("me.")) {
                return "Local";
            } else if (
                window.location.hostname.endsWith(".testkontur.ru") &&
                window.location.hostname.startsWith("forms")
            ) {
                return "TestForms";
            } else if (window.location.hostname.endsWith(".testkontur.ru")) {
                return "Cloud";
            } else if (window.location.hostname.endsWith(".dev.kontur.ru")) {
                return "Unknown";
            } else if (window.location.hostname.endsWith(".kontur.ru")) {
                return "Production";
            } else {
                return "Unknown";
            }
        } else {
            return "Local";
        }
    }

    const currentClient = Sentry.getCurrentHub().getClient();

    try {
        if (currentClient == undefined) {
            // eslint-disable-next-line no-console
            console.log("Initialize Sentry from scratch...");
            Sentry.init({
                dsn: "https://51b19d6561eb4ec4ab08266c579fa74d@sentry.kontur.host/575",
                environment: getSentryEnvironment(),
                release:
                    process.env.ENGINE_NAME === "local"
                        ? undefined
                        : `kontur.candy.engine@${process.env.npm_package_version}`,
                integrations: [...Sentry.defaultIntegrations, new RewriteFrames()],
            });
            candyHub = Sentry.getCurrentHub();
            Sentry.addGlobalEventProcessor(async event => {
                if (isCandySentryEvent(event)) {
                    return event;
                }
                return null;
            });
        } else {
            // eslint-disable-next-line no-console
            console.log("Initialize Sentry from existing client...");
            const client = new Sentry.BrowserClient({
                dsn: "https://51b19d6561eb4ec4ab08266c579fa74d@sentry.kontur.host/575",
                environment: getSentryEnvironment(),
                release:
                    process.env.ENGINE_NAME === "local"
                        ? undefined
                        : `kontur.candy.engine@${process.env.npm_package_version}`,
                integrations: Sentry.defaultIntegrations,
                transport: Sentry.makeFetchTransport,
                stackParser: Sentry.defaultStackParser,
            });
            candyHub.bindClient(client);
            Sentry.addGlobalEventProcessor(async event => {
                if (!event.extra?.candy) {
                    if (isCandySentryEvent(event)) {
                        candyHub.captureEvent({
                            ...event,
                            event_id: uuid4(),
                            environment: undefined,
                            release: undefined,
                            extra: { candy: true },
                        });
                        return event;
                    }
                    return event;
                } else {
                    return event;
                }
            });
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
}
